/**
 * Attaches a shortened, shareable cart id (cartId) to custom checkout
 * button links before navigating, reusing the same encode + saveCart.json
 * shortener flow as the "Keep & Share Your Cart" app's envelope action.
 */
(function () {
  var SAVE_CART_URL = 'https://cdn.codeblackbelt.com/core/saveCart.json';

  var cachedEncodedCart = null;
  var cachedShortId = null;

  function encodeUnicodeSafeBase64(str) {
    return btoa(
      encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, hex) {
        return String.fromCharCode('0x' + hex);
      })
    );
  }

  function clearProperties(properties) {
    var json = JSON.stringify(properties || {}).replace(/data:image\/[^"]+/g, '');
    return JSON.parse(json);
  }

  function encodeCart(cart) {
    var items = cart.items.map(function (item) {
      return {
        id: item.id,
        quantity: item.quantity,
        properties: clearProperties(item.properties),
      };
    });
    return encodeUnicodeSafeBase64(JSON.stringify(items));
  }

  function getCart() {
    return fetch(window.routes.cart_url + '.js').then(function (res) {
      return res.json();
    });
  }

  function getOrCreateShortId(cart) {
    var encodedCart = encodeCart(cart);
    if (cachedShortId && encodedCart === cachedEncodedCart) {
      return Promise.resolve(cachedShortId);
    }

    return fetch(SAVE_CART_URL + '?timestamp=' + Date.now(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ encodedCart: encodedCart, shop: window.shopDomain }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        cachedEncodedCart = encodedCart;
        cachedShortId = data.value;
        return cachedShortId;
      });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-cart-share-checkout]');
    if (!link) return;

    event.preventDefault();
    var destination = link.href;

    getCart()
      .then(function (cart) {
        if (cart.item_count === 0) {
          window.location.href = destination;
          return;
        }

        return getOrCreateShortId(cart).then(function (shortId) {
          var url = new URL(destination, window.location.origin);
          url.searchParams.set('cartId', shortId);
          window.location.href = url.toString();
        });
      })
      .catch(function (error) {
        console.error('cart-share: falling back to plain checkout link', error);
        window.location.href = destination;
      });
  });
})();
